import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { FormWrapperStyled as EditProductRatesFormWrapperStyled } from '../EditProductRatesForm/styles';

export const RatesConfigurationZoneStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 3rem 0 2rem;

  @media (width < 850px) {
    flex-direction: column;
    gap: 2rem;

    > ${EditProductRatesFormWrapperStyled}:not(:last-child) {
      border-bottom: 1px solid ${colors.neutral[300]};
      padding-bottom: 3rem;
    }
  }

  @media (width >= 850px) {
    > ${EditProductRatesFormWrapperStyled}:nth-child(2n) {
      border-left: 1px solid ${colors.neutral[300]};
      padding-left: 4rem;
    }

    > ${EditProductRatesFormWrapperStyled}:nth-child(n + 3) {
      margin-top: 6rem;
    }
  }
`;
